import { add, remove } from "@fluorescent/dom";
import { shouldAnimate, delayOffset } from "@/lib/animation";

const selectors = {
  animationItems: `
    .quick-add__product,
    .product-form__controls-group,
    .product__policies,
    .store-availability-container__wrapper
  `,
};

const classes = {
  animationRevealed: "animation--revealed",
};

export default node => {
  if (!shouldAnimate(node)) return;

  // Trigger the reveal animation when the drawer is opened
  function open() {
    delayOffset(node, [selectors.animationItems]);
    setTimeout(() => {
      add(node, classes.animationRevealed);
    }, 100);
  }

  // Reset the reveal animation when the drawer is closed
  function close() {
    remove(node, classes.animationRevealed);
  }

  return {
    open,
    close,
  };
};
